import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddRawProdGin, EditRawProdGin, RawProd, RawProdGin, RawProdSource } from './rawProd.types';

export const useGetRawProducts = (
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<RawProd[]>>({
    queryKey: 'rawprod',
    queryFn: () => apiClient.get<RawProd[]>('/raw-prods'),
    enabled
  });
};

export const useRawProdSource = (requestBody: { unused?: boolean }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<RawProdSource[]>>({
    queryKey: ['rawprodsource', requestBody.unused],
    queryFn: () => apiClient.get<RawProdSource[]>('/raw-prod-source', { params: requestBody }),
    enabled,
  });
};

export const useAddNewRawProdGins = () => {
  return useMutation((record: AddRawProdGin) => {
    return apiClient.post(`/raw-prod-gins/`, record)
  })
}

export const useEditRawProdGin = () => {
  return useMutation((record: EditRawProdGin) => {
    return apiClient.put(`/raw-prod-gins/convFactor`, record);
  });
};

export const useRawProdGinsUploadFile = () => {
  return useMutation((record: FormData) => {
    return apiClient.post(`/raw-prod-gins/upload/`, record);
  });
};

export const useRawProdGins = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<RawProdGin[]>>({
    queryKey: 'rawprod',
    queryFn: () => apiClient.get<RawProdGin[]>('/raw-prod-gins'),
    enabled,
  });
};


export const useDeleteRawProdGins = () => {
  return useMutation((id: string) => {
    return apiClient.delete(`/raw-prod-gins/${id}`);
  });
};

export const useRawProdSourceById = (id: string, enabled: boolean = false) => {
  return useQuery<AxiosResponse<RawProdSource>>({
    queryKey: ['rawprod', id],
    queryFn: () => apiClient.get<RawProdSource>(`/raw-prod-source/${id}`),
    enabled,
  });
};

export const useEditRawProd = (moaRawProdNo: string | undefined) => {
  return useMutation((record: RawProdSource) => {
    return apiClient.put(`/raw-prod-source/${moaRawProdNo}`, record);
  });
};

export const useAddRawProd = (likeNation: boolean = false) => {
  return useMutation((record: RawProdSource) => {
    return apiClient.post(`/raw-prod-source`, record, {
      params: {
        likeNation,
      },
    });
  });
};

export const useAddRawProductOverrides = (id: string) => {
  return useMutation((record: string[]) => {
    return apiClient.post(`/raw-prod-source/overrides/${id}`, record);
  });
};

export const useRawProdsInMenu = (requestBody: { menuNo: string, mxRef: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<RawProdSource[]>>({
    queryKey: ['rawprods-in-menus', requestBody.menuNo, requestBody.mxRef],
    queryFn: () => apiClient.get<RawProdSource[]>(`/menus/${requestBody.menuNo}/raw-prods`, { params: requestBody }),
    enabled,
  });
};

export const useDeleteRawProd = () => {
  return useMutation((rawProdNos: string[]) => {
    return apiClient.delete(`/raw-prods`, {data: rawProdNos});
  });
};

export const useCheckRawProd = () => {
  return useMutation((rawProdNo: string[]) => {
    return apiClient.post(`raw-prods/associations`, rawProdNo);
  });
}

export const useSubRecipeDetailRawProducts = (
  requestBody: {
    specs: number[];
    classNo: number | undefined;
    baseNo?: number | null;
    sizeNo?: number | null;
    prodNo?: number | null;
    optionNo?: number | null;
  },
  enabled: boolean = true
) => {
  return useQuery<AxiosResponse<RawProd[]>>({
    queryKey: [
      'sub-recipe-detail-raw-products',
      requestBody.specs,
      requestBody.classNo,
      requestBody.baseNo,
      requestBody.sizeNo,
      requestBody.prodNo,
      requestBody.optionNo,
    ],
    queryFn: () => apiClient.post<RawProd[]>('/sub-recipes/details/raw-products', requestBody),
    enabled,
  });
};